import { updateShipment } from '../../../root/reducers/shipments'
import get from 'lodash/get'
import { makeAllocations, getAddedProducts } from './utils'

export const createSnapshot = (opts, shipment) => async (dispatch, getState, { api }) => {
  const shipmentId = shipment.id
  const shipmentTypeId = shipment.shipmentType
    ? shipment.shipmentType.id
    : 'routine'

  const { syncWithAllocation, checkPersistEpod = false } = opts
  delete opts.syncWithAllocation
  delete opts.checkPersistEpod

  const params = {
    ...shipment,
    shipmentTypeId,
    ...opts,
    parentDocId: shipment.snapshotId
  }

  let shouldPersist = true
  const originId = get(shipment, 'origin.id')

  // For certain tenants, we conditional check if we want to persist (save to db) shipments.
  // Only gate the "received" snapshot, and default to persisting when offline.
  const shouldLog = checkPersistEpod && params.status === 'received' && originId

  if (shouldLog) {
    try {
      const response = await api.shipment.getBucketObject({ configKey: originId })
      shouldPersist = !(response && response.dryRun === true)
    } catch (error) {
      shouldPersist = true
    }
  }

  if (!shouldPersist) {
    const snapshotPayload = await api.shipment.createSnapshot({ ...params, dryRun: true })
    if (shouldLog) {
      try {
        await api.shipment.logToS3({ payload: snapshotPayload })
      } catch (error) {
        // Logging failure should not block local workflow
      }
    }
    const optimisticShipment = Object.assign({}, shipment, { status: params.status })
    dispatch(updateShipment(optimisticShipment))
    return optimisticShipment
  }

  if (syncWithAllocation) {
    const shipments = await api.shipment.find({location: shipmentId}, {checkSnapShotLocation: true})

    // It's ok if we don't find shipments here
    // we only need it if we need to update SL allocations
    const dbShipment = shipments[0]

    // For SL: modification of new shipment while packing to add new products
    // needs to be synced with allocation md, which means this process requires
    // the user to be online
    const status = get(dbShipment, 'status')

    if (status === 'new') {
      const newProducts = getAddedProducts(params)

      if (Object.keys(newProducts).length) {
        const facilityId = dbShipment.destination.id
        const currentAllocation = await api.allocation.getConfiguration({ facilityId })

        await api.allocation.addConfiguration({
          configurations: [{
            facilityId,
            products: Object.assign({}, currentAllocation.products, makeAllocations('directOrder', newProducts)),
            unsubscriptions: Object.assign({}, currentAllocation.unsubscriptions)
          }],
          effectiveDate: currentAllocation.date,
          noAggregate: true
        })
      }
    }
  }

  const snapshotPayload = await api.shipment.createSnapshot(params)
  if (shouldLog) {
    try {
      await api.shipment.logToS3({ payload: snapshotPayload })
    } catch (error) {}
  }
  const updatedShipments = await api.shipment.find(shipmentId)

  // Online/offline case if you suddenly go offline in the middle of it all
  if (!updatedShipments.length) {
    throw new Error(`Shipment ${shipmentId} is not available`)
  }

  dispatch(updateShipment(updatedShipments[0]))
  // return the shipment, to be used by components using `withShipment`
  // that won't get the updated version via redux
  return updatedShipments[0]
}
